export default "__VITE_ASSET__BAJtLcBd__"